export default __webpack_public_path__ + "static/image5-4a5bbe369674b096b8331c33fd8e1302.gif";